module.exports = __webpack_public_path__ + "static/media/18.901bf313.jpg";